import { render, staticRenderFns } from "./administrationTrainingModuleConfiguration.vue?vue&type=template&id=b7fe13da&scoped=true&"
import script from "./administrationTrainingModuleConfiguration.vue?vue&type=script&lang=js&"
export * from "./administrationTrainingModuleConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./administrationTrainingModuleConfiguration.vue?vue&type=style&index=0&id=b7fe13da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fe13da",
  null
  
)

export default component.exports